export const selectIsSocketDisconnected = ({ socket: { isDisconnected } }) => isDisconnected;

export default {
  selectIsSocketDisconnected,
};
